import React, { forwardRef } from "react";
import { css, Theme, useTheme } from "@emotion/react";

type Props = {
    countryName?: string,
    showOptions?: boolean
};

const DropdownPlaceholder = forwardRef<HTMLDivElement, Props>(({
    countryName = "",
    showOptions = false,
}, ref) => {
    const theme:Theme = useTheme();

    const style = css`
        padding-right: 17px;
        white-space: nowrap;
        color: ${showOptions ? theme.colours.curiousBlue : "black"};
        cursor: pointer;
    `;

    return (
        <div css={style} ref={ref}>
            {countryName}
        </div>
    );
});

export default DropdownPlaceholder;